import { Helmet } from 'react-helmet';
import PageHeader from '../Common/PageHeader';
import MyWishlist from './../UserAccount/MyWishlist';

const WishlistPage = () => {
  return (
    <>
      <Helmet>
        <title>
          Save your Preferred Unique Home Products in your Wishlist{' '}
        </title>
        <meta
          name="keywords"
          content="new unique items,creative items for home,creative home decor items,creative decorative items,creative products to sell online,creative memories items for sale,creative gift supplies,creative item for home and office,unique products for home,unique home products,unique office wall decor,interesting home products,unique decorative pieces,unique home essentials,funky home decor items,unique home decorative items,unique home office decor,unique household gadgets"
        />
        <meta
          name="description"
          content="Save your chosen Unique Home Products in your Wishlist to Purchase or see whenever you want. So that you can avail the chance of purchasing specific item on time"
        />
      </Helmet>
      <PageHeader title="Bakumia Wishlist" />

      {/* <!-- cart + summary --> */}
      <section className="container-fluid py-4">
        <div className="row">
          <div className="col-12">
            {/* Wishlist Header */}
            <div className="text-center mb-5">
              <h2 className="fw-bold">Wishlist</h2>
              <hr className="mx-auto w-25" />
              <p className="mt-3 px-md-5">
                If your favorite unique home product has sold out, don’t worry —
                you can add it to your Wishlist. That way, you can purchase it
                after restocking or quickly find it whenever you want.
              </p>
            </div>

            {/* Wishlist Items */}
            <MyWishlist />
          </div>
        </div>
      </section>
    </>
  );
};

export default WishlistPage;
